import { groupBy, head, toUpper } from 'ramda';

import { IOrderedList, IListItem, IListItems } from '@folx-types/data';

type ConvertToOrderedList = (list: IListItems) => IOrderedList;
export const convertToOrderedList: ConvertToOrderedList = (list) => {
	const orderedList = groupBy((item: IListItem) => {
		return head(toUpper(item.label));
	}, list);
	return orderedList;
};
